export class WeightUnit {
    Code: string;
    Name: string;
    PrintAs: string;
  }